<template>
	<page :loading="loading">
		<div slot="header" class="flex-row">
			<div class="flex-item page_header">
				<el-form size="small" :inline="true">
					<el-form-item label="保单号">
						<el-input v-model="table.search.policy_no" placeholder="请输入保单号" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="报案号">
						<el-input v-model="table.search.register_no" placeholder="请输入报案号" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="赔案号">
						<el-input v-model="table.search.claim_no" placeholder="请输入赔案号" clearable>
						</el-input>
					</el-form-item>
					
					<el-form-item label="团队长">
						<el-select-search v-model="table.search.user_pid" api="getTeam" lakey="id" label="nickname" clearable placeholder="请输入手机号/昵称/ID"/>
					</el-form-item>
					
					<!-- 新增查询字段：报案时间范围 -->
					<el-form-item label="报案时间">
						<el-date-picker
							v-model="table.search.regist_time_range"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							@change="handleRegistTimeChange"
							clearable>
						</el-date-picker>
					</el-form-item>
					
					<!-- 新增查询字段：结案时间范围 -->
					<el-form-item label="结案时间">
						<el-date-picker
							v-model="table.search.claim_time_range"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							@change="handleClaimTimeChange"
							clearable>
						</el-date-picker>
					</el-form-item>
					
					<!-- 新增查询字段：保险产品 -->
					<el-form-item label="保险产品">
						<el-input v-model="table.search.goods_name" placeholder="请输入保险产品" clearable>
						</el-input>
					</el-form-item>
					
					<!-- 新增查询字段：承保公司 -->
					<el-form-item label="承保公司">
						<el-input v-model="table.search.insurer_name" placeholder="请输入承保公司" clearable>
						</el-input>
					</el-form-item>
					
					<el-form-item label="案件状态">
						<el-select clearable v-model="table.search.case_status" placeholder="请选择" clearable>
							<el-option value="00" label="未提交"></el-option>
							<el-option value="01" label="立案录入"></el-option>
							<el-option value="02" label="立案审核"></el-option>
							<el-option value="03" label="定损"></el-option>
							<el-option value="04" label="核损"></el-option>
							<el-option value="05" label="核损初审"></el-option>
							<el-option value="06" label="核损复审"></el-option>
							<el-option value="07" label="单证确认"></el-option>
							<el-option value="08" label="结案理算"></el-option>
							<el-option value="09" label="结案核赔"></el-option>
							<el-option value="11" label="已决已结（正常结案）"></el-option>
							<el-option value="12" label="已决已结（零赔付）"></el-option>
							<el-option value="13" label="已决已结（拒赔）"></el-option>
							<el-option value="14" label="已决已结（立案注销）"></el-option>
							<el-option value="15" label="报案注销"></el-option>
							<el-option value="25" label="已决未结"></el-option>
							<el-option value="26" label="已决已结"></el-option>
							<el-option value="27" label="结案核赔"></el-option>
							<el-option value="28" label="结案理算"></el-option>
							<el-option value="19" label="结案理算（零注拒）"></el-option>
							<el-option value="20" label="结案核赔（零注拒）"></el-option>
							<el-option value="10" label="已决未结（正常结案）"></el-option>
							<el-option value="16" label="已决未结（零结案）"></el-option>
							<el-option value="17" label="已决未结（拒赔）"></el-option>
							<el-option value="18" label="已决未结（立案注销）"></el-option>
							<el-option value="29" label="核价"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="理赔状态">
						<el-select clearable v-model="table.search.status" placeholder="请选择" clearable>
							<el-option :value="0" label="进行中"></el-option>
							<el-option :value="1" label="已完成"></el-option>
							<el-option :value="2" label="未通过"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="赔付状态">
						<el-select clearable v-model="table.search.settle_status" placeholder="请选择" clearable>
							<el-option :value="1" label="已赔付"></el-option>
							<el-option :value="0" label="未赔付"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" plain @click="LoadDatas(1,20)">
							查询
						</el-button>
						<el-button size="small" type="info" plain @click="reset">
							重置
						</el-button>
						<el-button size="small" type="success" plain @click="exportExcel" :loading="exportLoading">
							导出Excel
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<page-table @sortChange="sortChange" :datas="table.data" :page="table.search._page" :size="table.search._size"
			:total="table._count" @change="LoadDatas">
			<el-table-column prop="id" label="理赔ID" align="center" fixed="left" width="100" />
			<el-table-column prop='policy_no' label='保单号' align='center' width="200" />
			<el-table-column prop='register_no' label='报案号' align='center' width="180" />
			<el-table-column prop='claim_no' label='赔案号' align='center' width="180" />
			<el-table-column label="保险产品" show-overflow-tooltip width="200">
				<template slot-scope="scope">
					<div class="goods">
						<div class="goods-name">{{ scope.row.goods_name }}</div>
						<div class="goods-specs">{{ scope.row.goods_specs_name }}</div>
						<div class="goods-specs">{{ scope.row.insurer_name }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="被保险人" align="center" show-overflow-tooltip width="150">
				<template slot-scope="scope">
					<div>{{ scope.row.insurant_name }}</div>
					<div class="cert-info">{{ getCertTypeText(scope.row.insurant_cert_type) }}:
						{{ scope.row.insurant_cert_no }}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="报案信息" align="center" show-overflow-tooltip width="200">
				<template slot-scope="scope">
					<div>{{ scope.row.reporter }}</div>
					<div>{{ scope.row.reporter_telephone }}</div>
					<div class="regist-time">{{ scope.row.regist_time }}</div>
				</template>
			</el-table-column>
			<el-table-column prop='claim_amount' label='赔付金额' align='center' width="120">
				<template slot-scope="scope">
					<span class="amount">¥{{ scope.row.claim_amount }}</span>
				</template>
			</el-table-column>
			<el-table-column label="案件状态" align="center" width="120">
				<template slot-scope="scope">
					<el-tag :type="getCaseStatusTagType(scope.row.case_status)" size="small">
						{{ getCaseStatusText(scope.row.case_status) }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="理赔状态" align="center" width="100">
				<template slot-scope="scope">
					<el-tag :type="getStatusTagType(scope.row.status)" size="small">
						{{ scope.row.statusText }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="赔付状态" align="center" width="100">
				<template slot-scope="scope">
					<el-tag :type="scope.row.settle_status ? 'success' : 'warning'" size="small">
						{{ scope.row.settle_status ? '已赔付' : '未赔付' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop='created_at' label='创建时间' align='center' width="180" />
			<el-table-column label="操作" align="center" fixed="right" width="120">
				<template slot-scope="scope">
					<el-popover placement="bottom" width="120" trigger="click">
						<div class="btn" @click="showClaimDetail(scope.row)">详情</div>
						<el-button slot="reference" type="text" size="small">更多</el-button>
					</el-popover>
				</template>
			</el-table-column>
		</page-table>

		<el-drawer :modal="false" v-if="detailDialog" title="保单信息" size="100%" :visible.sync="detailDialog">
			<claim-detail v-if="detailDialog" :id="currentClaim.id" @close="closeDetailDialog" />
		</el-drawer>
	</page>
</template>

<script>
	import ClaimDetail from '../component/claimInfo.vue';

	export default {
		components: {
			ClaimDetail,
		},
		data() {
			return {
				loading: false,
				exportLoading: false, // 导出加载状态
				table: {
					data: [],
					form: {},
					search: {
						_page: 1,
						_size: 20,
						_order: 'id',
						_isreverse: 1,
						goods_name: '', // 新增：保险产品
						insurer_name: '', // 新增：承保公司
						regist_time_range: [], // 新增：报案时间范围
						claim_time_range: [] // 新增：结案时间范围
					},
					_count: 0,
				},
				detailDialog: false,
				fileDialog: false,
				currentClaim: {},
				statusForm: {
					case_status: '',
					status: 0,
					settle_status: 0,
					claim_amount: 0,
					return_reason: ''
				}
			}
		},
		computed: {
			hasEditPermission() {
				// 根据用户权限判断是否有编辑权限
				return true;
			}
		},
		mounted() {
			this.LoadDatas();
		},
		methods: {
			// 处理报案时间范围变化
			handleRegistTimeChange(range) {
				if (range && range.length === 2) {
					this.table.search.regist_timestart = range[0];
					this.table.search.regist_timeend = range[1];
				} else {
					delete this.table.search.regist_timestart;
					delete this.table.search.regist_timeend;
				}
			},
			
			// 处理结案时间范围变化
			handleClaimTimeChange(range) {
				if (range && range.length === 2) {
					this.table.search.claim_timestart = range[0];
					this.table.search.claim_timeend = range[1];
				} else {
					delete this.table.search.claim_timestart;
					delete this.table.search.claim_timeend;
				}
			},
			
			async exportExcel() {
				this.exportLoading = true;
				try {
					// 构建导出参数
					const exportParams = this.$buildExportParams(this.table.search);
			
					// 调用导出
					await this.$export('claimExport', exportParams, '理赔列表');
				} catch (error) {
					this.$message.warning(error);
				} finally {
					this.exportLoading = false;
				}
			},
			// 获取证件类型文本
			getCertTypeText(type) {
				const typeMap = {
					'01': '身份证',
					'02': '护照',
					'03': '港澳居民往来内地通行证',
					'04': '台湾居民往来大陆通行证'
				};
				return typeMap[type] || '未知';
			},

			// 获取案件状态文本
			getCaseStatusText(status) {
				const statusMap = {
					'00': '未提交',
					'01': '立案录入',
					'02': '立案审核',
					'03': '定损',
					'04': '核损',
					'05': '核损初审',
					'06': '核损复审',
					'07': '单证确认',
					'08': '结案理算',
					'09': '结案核赔',
					'11': '已决已结',
					'12': '零赔付',
					'13': '拒赔',
					'14': '立案注销',
					'15': '报案注销',
					'25': '已决未结',
					'26': '已决已结',
					'27': '结案核赔',
					'28': '结案理算',
					'19': '结案理算',
					'20': '结案核赔',
					'10': '已决未结',
					'16': '零结案',
					'17': '拒赔',
					'18': '立案注销',
					'29': '核价'
				};
				return statusMap[status] || '未知';
			},

			// 获取案件状态标签类型
			getCaseStatusTagType(status) {
				if (['00'].includes(status)) return 'info';
				if (['11', '12', '13', '14', '15', '26'].includes(status)) return 'success';
				if (['01', '02', '03', '04', '05', '06', '07'].includes(status)) return 'warning';
				if (['08', '09', '10', '16', '17', '18', '19', '20', '25', '27', '28', '29'].includes(status))
					return 'info';
				return 'info';
			},

			// 获取状态标签类型
			getStatusTagType(status) {
				const typeMap = {
					0: 'warning', // 进行中
					1: 'success', // 已完成
					2: 'danger' // 未通过
				};
				return typeMap[status] || 'info';
			},

			// 显示理赔详情
			showClaimDetail(claim) {
				this.currentClaim = claim;
				this.detailDialog = true;
			},

			// 查看文件
			viewFiles(claim) {
				this.currentClaim = claim;
				this.fileDialog = true;
			},

			// 处理赔付
			processPayment(claim) {
				this.$confirm('确定要处理赔付吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$post('processClaimPayment', {
						id: claim.id
					}).then(res => {
						this.$success('赔付处理成功');
						this.LoadDatas();
					}).catch(err => {
						this.$warning(err || '处理失败');
					});
				});
			},

			// 关闭详情对话框
			closeDetailDialog() {
				this.detailDialog = false;
				this.currentClaim = {};
			},

			reset() {
				this.table.search = {
					_page: 1,
					_size: 20,
					_order: '',
					_isreverse: 1,
					goods_name: '',
					insurer_name: '',
					regist_time_range: [],
					claim_time_range: []
				};
				this.LoadDatas();
			},

			sortChange(e) {
				var isreverse = 1;
				if (e.order == null) {
					this.reset();
				} else if (e.order == 'descending') {
					var isreverse = 1;
				} else if (e.order == 'ascending') {
					var isreverse = 0;
				}
				this.table.search = {
					_page: 1,
					_size: 20,
					_order: e.prop,
					_isreverse: isreverse,
					goods_name: this.table.search.goods_name,
					insurer_name: this.table.search.insurer_name,
					regist_time_range: this.table.search.regist_time_range,
					claim_time_range: this.table.search.claim_time_range
				};
				// 重新设置时间范围参数
				if (this.table.search.regist_time_range && this.table.search.regist_time_range.length === 2) {
					this.table.search.regist_timestart = this.table.search.regist_time_range[0];
					this.table.search.regist_timeend = this.table.search.regist_time_range[1];
				}
				if (this.table.search.claim_time_range && this.table.search.claim_time_range.length === 2) {
					this.table.search.claim_timestart = this.table.search.claim_time_range[0];
					this.table.search.claim_timeend = this.table.search.claim_time_range[1];
				}
				this.LoadDatas();
			},

			/**
			 * 获取数据列表
			 * @param page 分页-当前页
			 * @param size 分页-每页数量
			 * **/
			LoadDatas(page, size) {
				page && (this.table.search._page = page), size && (this.table.search._size = size), this.loading = true;
				// 确保时间范围参数已设置
				if (this.table.search.regist_time_range && this.table.search.regist_time_range.length === 2) {
					this.table.search.regist_timestart = this.table.search.regist_time_range[0];
					this.table.search.regist_timeend = this.table.search.regist_time_range[1];
				}
				if (this.table.search.claim_time_range && this.table.search.claim_time_range.length === 2) {
					this.table.search.claim_timestart = this.table.search.claim_time_range[0];
					this.table.search.claim_timeend = this.table.search.claim_time_range[1];
				}
				
				this.$get('app-order-claim', this.table.search).then(res => {
					this.table.data = res.data, this.table._count = res.extra.pageInfo.count, this.loading = false;
				}).catch(err => {
					this.$notify.error({
						message: err || '网络请求错误'
					}), this.loading = false;
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
	.page_header {
		margin: 10px 10px 0;
		position: absolute;
		z-index: 100;
	}

	.goods {
		.goods-name {
			font-weight: bold;
			margin-bottom: 5px;
		}

		.goods-specs {
			font-size: 12px;
			color: #666;
		}
	}

	.cert-info {
		font-size: 12px;
		color: #999;
		margin-top: 2px;
	}

	.regist-time {
		font-size: 12px;
		color: #999;
		margin-top: 2px;
	}

	.amount {
		font-weight: bold;
		color: #e6a23c;
	}

	.btn {
		cursor: pointer;
		width: 100%;
		padding: 5px;
		font-size: 12px;
	}

	.btn:hover {
		background-color: #ecf3fd;
		color: #3E84E9;
	}
</style>